import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class MstNonDrugAllergyService {
  mstNonDrugAllergy: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'mst_non_drug_allergy/list?';
  private AddRecord = webapi + 'mst_non_drug_allergy/create';
  private EditRecord = webapi + 'mst_non_drug_allergy/update';
  private GetRecord = webapi + 'mst_non_drug_allergy/byid/';
  private DeleteRecord = webapi + 'mst_non_drug_allergy/delete/';
  private GetDropDown = webapi + 'mst_non_drug_allergy/dropdown?';
  private ReActiveRecord = webapi + 'mst_non_drug_allergy/reActive/';
  private DeListRecord = webapi + 'mst_non_drug_allergy/deactivated_list/?';


    constructor(
    private http: Http
  ) {
  }
    getAllDeactivatedRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        // console.log(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col);
        return this.http.get(this.DeListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    reActiveRecordService(id: any) {
        return this.http.put(this.ReActiveRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getNonAllergy(page: any, size: any) {
    return this.http.get(this.ListRecord + 'page=' + page + '&size=' + size + '&qString=' + '' + '&sort=' + '' + '&col=' + '')
      .toPromise()
      .then(res => <any[]> res.json().content)
      .then(data => {
        // console.log(data);
        return data;
      });
  }

  getDropDown(currentPage: any, size: any, globalFilter: any): Promise<any> {
    return this.http.get(this.GetDropDown + 'page=' + currentPage + '&size=' + size + '&globalFilter=' + globalFilter)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/mst-non-drug-allergy/mst-non-drug-allergy.service.ts